<template>
    <Container>
        <!-- Page Header -->
        <div class="bg-gradient-to-r from-nomad-800 to-nomad-900 rounded-lg overflow-hidden mb-8 p-6 md:p-8">
            <div class="text-center">
                <h1 class="text-white font-bold text-3xl md:text-5xl mb-2">Just Added</h1>
                <p class="text-nomad-300">New to Heesify</p>
            </div>
        </div>

        <!-- Songs List -->
        <ul v-if="justadded && justadded.length" class="space-y-3">
            <li v-for="(song, index) in justadded" :key="song.id">
                <JustAdded :song="song" :jumbo="index == 0" />
            </li>
        </ul>

        <!-- Loading Skeleton -->
        <ul v-else-if="!justadded" class="space-y-3">
            <li v-for="i in 5" :key="i">
                <JustAddedPlaceholder />
            </li>
        </ul>

        <!-- Empty State -->
        <div v-else class="text-center py-12">
            <p class="text-nomad-300 text-lg">No recently added songs</p>
        </div>
    </Container>
</template>
<script>
import { defineAsyncComponent } from 'vue'
import { Link, usePage } from "@inertiajs/vue3";
import { mapState, mapActions, mapGetters } from "vuex";
import JustAdded from "@/components/JustAdded.vue";
import { JustAddedPlaceholder } from "@/components/placeholders/placeholder.js";
const page = usePage();

export default {
    created() {
        this.getAllJustAdded();
    },
    methods: {
        ...mapActions("justadded", ["getAllJustAdded"]),
    },
    computed: {
        ...mapState({ justadded: (state) => state.justadded.all }),
    },
    components: {
        JustAdded,
        JustAddedPlaceholder,
        'adsense': defineAsyncComponent(() => import("@/components/Adsense.vue")),
    },
    beforeMount() {
        document.title = page.props.title
    },
}
</script>